import React,{ Component } from 'react';
import {Row, Col, Button, ButtonGroup, Alert} from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';
import countriesObj from "../../../../data/countries";
import { handleFieldChange } from "../../../../Utils";

const countriesOptions = Object.assign({ all: 'All' }, countriesObj);

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            source: null,
            affid: null,
            country: null,
            dateFrom: '',
            dateTo: ''
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFormSubmit(type) {
        const isValid = this.validateForm();
        const filters = Object.assign({}, this.state);

        if(isValid) this.props.onSubmit(filters, type);
    }

    validateForm() {
        const { dateFrom, dateTo } = this.state;

        let alert = null;

        if(!dateFrom) alert = 'Please set Date From';
        else if(!dateTo) alert = 'Please set Date To';
        else if(dateFrom > dateTo) alert = 'Date range invalid!';

        this.setState({ alert });

        return !alert;
    }

    getAlert() {
        const { alert } = this.state;

        if(alert) return <Alert bsStyle={'danger'}>{alert}</Alert>
    }

    render() {
        return (
            <form>
                {this.getAlert()}
                <Row>
                    <Col lg={4}>
                        <FieldGroup
                            type="date"
                            name="dateFrom"
                            label="Date From:"
                            onChange={this.handleFieldChange}
                            value={this.state.dateFrom}
                        />
                    </Col>
                    <Col lg={4}>
                        <FieldGroup
                            type="date"
                            name="dateTo"
                            label="Date To:"
                            onChange={this.handleFieldChange}
                            value={this.state.dateTo}
                        />
                    </Col>
                    <Col lg={4}>
                        <SelectWrap
                            values={this.props.sources}
                            label="Source:"
                            name="source"
                            onChange={this.handleFieldChange}
                            value={this.state.source}
                            multi
                        />
                    </Col>
                </Row>
                <Row>
                    <Col lg={4}>
                        <SelectWrap
                            values={this.props.affidValues}
                            label="Affid:"
                            name="affid"
                            onChange={this.handleFieldChange}
                            value={this.state.affid}
                            multi
                        />
                    </Col>
                    <Col lg={4}>
                        <SelectWrap
                            values={countriesOptions}
                            label="Countries:"
                            name="country"
                            onChange={this.handleFieldChange}
                            value={this.state.country}
                            multi
                        />
                    </Col>
                </Row>
                <ButtonGroup>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit('affid')}>Load Affid</Button>
                    <Button type="button" bsStyle="info" className="m-b-15" onClick={() => this.handleFormSubmit('')}>Load Report</Button>
                </ButtonGroup>
            </form>
        );
    }
}

export default Filters;


// WEBPACK FOOTER //
// ./src/scenes/BidderCtr/components/Form/index.js